var hookTypes = ['after', 'before', 'onError'];
export var isValidHookType = function isValidHookType(type) {
  return new RegExp(hookTypes.join('|')).test(type);
};
export var SHOW_HOOK_NODE = !!process.env.NEXT_PUBLIC_SHOW_HOOK_NODES;
export function fromSpecificToShallowType(value) {
  return value;
}
export function fromShallowToSpecificType(value) {
  return value;
}
export function makeEditorId(id, type) {
  return "".concat(type, "-").concat(id);
}
export function incrementString(value, amount) {
  var newValue = parseInt(fromSpecificToShallowType(value), 10);
  return fromShallowToSpecificType("".concat(newValue + amount));
}
export var OS;

(function (OS) {
  OS["Windows"] = "Windows";
  OS["Mac"] = "Mac";
  OS["Linux"] = "Linux";
  OS["Android"] = "Android";
  OS["iOS"] = "iOS";
  OS["Other"] = "Other";
})(OS || (OS = {}));

export function getOS() {
  var userAgent = window.navigator.userAgent.toLowerCase();
  var macosPlatforms = /(macintosh|macintel|macppc|mac68k|macos)/;
  var windowsPlatforms = /(win32|win64|windows|wince)/;
  var iosPlatforms = /(iphone|ipad|ipod)/;

  if (macosPlatforms.test(userAgent)) {
    return OS.Mac;
  }

  if (iosPlatforms.test(userAgent)) {
    return OS.iOS;
  }

  if (windowsPlatforms.test(userAgent)) {
    return OS.Windows;
  }

  if (/android/.test(userAgent)) {
    return OS.Android;
  }

  if (/linux/.test(userAgent)) {
    return OS.Linux;
  }

  return OS.Other;
}